export enum ResourceRoleEnum {
  "webapp-monitor-source" = "webapp-monitor-source",
  "webapp-seller-courier" = "webapp-seller-courier",
  "webapp-sup-courier" = "webapp-sup-courier",
}